import { usePanelRegistryStore } from '@/store';

/**
 * Hook to detect if any slideover panel or modal is currently open.
 * Used to offset toast notifications so they don't overlap with panel footer buttons.
 *
 * This hook uses a central panel registry store which tracks all open panels
 * across the application, reducing subscription count from 17 to 1.
 */
export function useIsAnyPanelOpen(): boolean {
  return usePanelRegistryStore((s) => s.isAnyOpen);
}
